import {StyleSheet} from "react-native"

export default StyleSheet.create({
  mb15: {
    marginBottom: 15
  },

  rootContainer: {},
  rootContainerMdUp: {
    rowGap: 30
  },
  rootContainerXxlUp: {
    flexDirection: "row"
  },

  rolesContainer: {},
  rolesContainerXxlUp: {
    flex: 3
  },

  yourRoleDescription: {
    marginBottom: 30,
    color: "#2c2c96",
    fontSize: 16,
    lineHeight: 27
  },

  yourRoleColumn: {
    paddingTop: 37
  },
  yourRoleColumnMdUp: {
    marginTop: "auto",
    marginBottom: "auto"
  },
  yourRoleColumnXxlUp: {
    flex: 2,
    paddingRight: 80
  },

  yourRoleWithDescription: {},
  yourRoleWithDescriptionMdUp: {
    marginTop: -12,
    marginLeft: 30
  },
  yourRoleWithDescriptionLgUp: {
    marginLeft: 52
  },

  yourRole: {
    marginBottom: -25,
    color: "#2c2c96",
    fontFamily: "DreamChaser",
    fontSize: 64,
    lineHeight: 109
  },
  yourRoleSmDown: {
    textAlign: "center"
  },
  yourRoleMdUp: {
    fontFamily: "DreamChaser",
    fontSize: 64
  }
})
